// eslint-disable-next-line
let data = {
    skuId: null,
    productId: null,
    siteId: null,
};

/**
 * @typedef {Object} ProductDict
 * @property {string} showMore
 * @property {string} msgAddToCartText
 * @property {string} msgAddedText
 * @property {string} msgServerError
 * @property {string} msgZeroQuantity
 * @property {string} msgEmptyQuantity
 * @property {string} productId
 * @property {string} siteId
 * @property {string} skuId
 * @property {string} options
 * @property {string} paginationTemplate
 * @property {string} allSubCategories
 * @property {string} allCategory
 * @property {string} loadMore
 * @property {string} filterSubCategory
 * @property {string} filterCategory
 * @property {string} phone
 * @property {string} filterText
 * @property {string} priceWithVat
 * @property {string} howToBuy
 * @property {string} homeLink
 * @property {string} noProductImageLabel
 */

/**
 * Return Data about current product + some common translation
 *
 * @returns {ProductDict} dict
 */
export const getProductData = () => {
    if (data.siteId === null) {
        data = { ...document.getElementById('common-strings').dataset };
    }
    return data;
};
